import environmentName from "./environmentName";
// TODO: do per-env builds with this env var set, or get it from atms-web-bff,
// so we don't have to infer it
const inferCookieFromHost = () => {
  return environmentName + "Session";
};
export default process.env.REACT_APP_SESSION_COOKIE_NAME ||
  inferCookieFromHost();
